<template>
  <component :is="criterio.tooltip ? 'mf-tooltip' : 'div'" max-width="350px" right>
    <template v-if="criterio.tooltip" #activator="{ on }">
      <new-criterio-card-menu
        :criterio="criterio"
        :group="group"
        :segmentation-groups="segmentationGroups"
        :is-dragged="isDragged"
        :show-badge="showBadge"
        :has-multiple-groups="hasMultipleGroups"
        v-on="on"
        @click-criteria="$emit('click-criteria', $event)"
        @dragstart="$emit('dragstart', $event, group)"
        @dragend="$emit('dragend')"
        @add-criteria="$emit('add-criteria', $event, group, arguments[2])"
      />
    </template>

    <new-criterio-card-menu
      v-if="!criterio.tooltip"
      :criterio="criterio"
      :group="group"
      :segmentation-groups="segmentationGroups"
      :is-dragged="isDragged"
      :show-badge="showBadge"
      :has-multiple-groups="hasMultipleGroups"
      @click-criteria="$emit('click-criteria', $event)"
      @dragstart="$emit('dragstart', $event, group)"
      @dragend="$emit('dragend')"
      @add-criteria="$emit('add-criteria', $event, group, arguments[2])"
    />

    <span v-if="criterio.tooltip">{{ criterio.tooltip }}</span>
  </component>
</template>

<script>
export default {
  components: {
    NewCriterioCardMenu: () => import('./NewCriterioCardMenu.vue'),
  },
  props: {
    criterio: {
      type: Object,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    tabIndex: {
      type: Number,
      required: true,
    },
    criterias: {
      type: Object,
      required: true,
    },
    segmentationGroups: {
      type: Array,
      required: true,
    },
    draggedObject: {
      type: Object,
      default: () => ({}),
    },
    isNewSegmentCriterias: {
      type: Function,
      required: true,
    },
  },
  computed: {
    hasMultipleGroups() {
      return this.segmentationGroups.length >= 2
    },
    isDragged() {
      return this.draggedObject.id === this.index && this.draggedObject.groupId === this.group.id
    },
    showBadge() {
      return this.isNewSegmentCriterias(`${this.criterias.children[this.tabIndex].label}.${this.group.label}.${this.criterio.label}`)
    },
  },
}
</script>
